import React from 'react';
import { useClient } from './ClientProvider';

export const SubscriptionPermissions = {
  // Generation permissions
  GenerationPostContent: 'generation.post.content',
  GenerationGetModel: 'generation.get.model',
  GenerationPostToolWebSearch: 'generation.post.tool.web-search',
  GenerationPostContentReasoning: 'generation.post.content.reasoning',
  GenerationPostContentVerbosity: 'generation.post.content.verbosity',
  GenerationPostContentPreamble: 'generation.post.content.preamble',
  GenerationPostToolFileSearch: 'generation.post.tool.file-search',
  GenerationPostToolRemoteMcp: 'generation.post.tool.mcp',

  // Flows permissions
  FlowGetNode: 'flow.get.node',
  FlowPostNode: 'flow.post.node',
  FlowPatchNode: 'flow.patch.node',
  FlowPostNodeAction: 'flow.post.node.action',
  FlowPostNodeLoop: 'flow.post.node.loop',
  FlowPostNodeAiAgent: 'flow.post.node.ai-agent',

  // Request viewer permissions
  RequestGetConversation: 'request.get.conversation',
  RequestPostExport: 'request.post.export',

  // Messenger permissions
  MessengerGetWindow: 'messenger.get.window',
  MessengerPatchStyle: 'messenger.patch.style',

  // AI Co-pilot Support permissions
  CoPilotGetSupport: 'co-pilot.get.support',

  // Assistant permissions
  BotPostInstruction: 'bot.post.instruction',
  BotPatchInstruction: 'bot.patch.instruction',
  BotPostVariableDefinitionPattern: 'bot.post.variableDefinition.pattern',
  BotPatchVariableDefinitionPattern: 'bot.patch.variableDefinition.pattern',

  // Dialog
  DialogGetTranslation: 'dialog.get.translation'
};

export default function useSubscription() {
  const { client } = useClient();

  const hasPermission = React.useCallback(
    permission => {
      if (client.subscription.active) {
        return client.subscription.permissions.includes(permission);
      }
      return false;
    },
    [client]
  );

  const permissions = client.subscription.permissions || [];
  const configurations = client.subscription.configurations || {};
  const name = client.subscription.name || '';

  return {
    name,
    permissions,
    configurations,
    active: client.subscription.active,
    hasPermission
  };
}
